import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const getUsersList: any = createAsyncThunk<any>(
	'getUsersList',
	async (data: any) => {
		const response = await httpService.get(`/system-portal/system-users`, {
			params: data
		});
		return response.data.data;
	}
);
export const getSystemUserDetails: any = createAsyncThunk<any>(
	'getSystemUserDetails',
	async (data: any) => {
		const response = await httpService.get(`/system-portal/user`, {
			params: data
		});
		return response.data.data;
	}
);
export const addSystemUser: any = createAsyncThunk<any>(
	'addSystemUser',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post('system-portal/user', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const editSystemUser: any = createAsyncThunk<any>(
	'editSystemUser',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(`/system-portal/user`, data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deleteSystemUser: any = createAsyncThunk<any>(
	'deleteSystemUser',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(`/system-portal/user`, {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const updateSystemUsersStatus: any = createAsyncThunk<any>(
	'updateSystemUsersStatus',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/system-portal/system-users`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const addAsssignTenants: any = createAsyncThunk<any>(
	'addAsssignTenants',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post(
				`/system-portal/assigned-tenant`,
				data
			);
			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getAssignTenantsList: any = createAsyncThunk<any>(
	'getAssignTenantsList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.get(
				`/system-portal/assigned-tenant`,
				{ params: data }
			);
			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const deleteAssignTenant: any = createAsyncThunk<any>(
	'deleteAssignTenant',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(
				`/system-portal/assigned-tenant`,
				{ params: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
